<template>
  <Legacy
    view="invoicing"
    action="invoices"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Invoices',
      breadcrumb: {
        name: 'Invoices',
        route: { name: 'billing-invoices' }
      }
    }
  }
}
</script>
